const hideDisclaimerOnSubmit = () => {
  const formSubmitted = document.getElementById( 'gform_confirmation_wrapper_1' )
  if ( formSubmitted ) {
    const disclaimer = document.querySelector<HTMLDivElement>( '.disclaimer' )
    if ( disclaimer ) disclaimer.style.display = 'none'
  }
}

export default hideDisclaimerOnSubmit